<template>
    <g>
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5 0.292969L16.7071 12.0001H9.79587L5 17.2973V0.292969ZM6 2.70718V14.7028L9.35228 11.0001H14.2929L6 2.70718Z" />
    </g>
</template>
